import { api, errorText } from "./api";
import { clear, el, fmtDate, fmtScore } from "./dom";
import { currentMe, ensureSession } from "./session";
import { type Sheet, openSheet, setStatus } from "./sheet";
import { starText } from "./stars";
import type { MyRating } from "./types";

export interface MyRatingsContext {
  openPlace(id: string, lat: number, lon: number): void;
}

/** "Értékeléseim": every rating this device has written, newest first. */
export async function openMyRatings(ctx: MyRatingsContext): Promise<void> {
  if (!currentMe()) {
    const me = await ensureSession("Adj meg egy becenevet, hogy lásd az értékeléseidet.");
    if (!me) return;
  }
  const sheet = openSheet("Értékeléseim");
  setStatus(sheet, "Betöltés…");
  await render(sheet, ctx);
}

async function render(sheet: Sheet, ctx: MyRatingsContext): Promise<void> {
  let ratings: MyRating[];
  try {
    ({ ratings } = await api.myRatings());
  } catch (err) {
    if (sheet.isOpen()) setStatus(sheet, errorText(err), "error");
    return;
  }
  if (!sheet.isOpen()) return;

  clear(sheet.body);
  if (ratings.length === 0) {
    sheet.body.append(
      el("p", { class: "empty", text: "Még nincs értékelésed. Keress egy helyet a térképen, és mondd el, mennyire ropogós!" }),
    );
    return;
  }

  const list = el("div", { class: "ratings" });
  for (const r of ratings) {
    const row = el("button", { class: "my-row", type: "button" }, [
      el("span", { class: "my-row__head" }, [
        el("span", { class: "my-row__name", text: r.hidden ? `${r.place_name} (rejtett)` : r.place_name }),
        el("span", { class: "rating__overall", text: fmtScore(r.overall) }),
      ]),
      el("span", {
        class: "rating__scores",
        text: `Ropogósság ${starText(r.crispiness)} · Íz ${starText(r.taste)} · Ár-érték ${starText(r.value)}`,
      }),
      r.comment ? el("span", { class: "rating__comment", text: r.comment }) : null,
      el("span", { class: "rating__date", text: fmtDate(r.created_at) }),
    ]);
    row.addEventListener("click", () => ctx.openPlace(r.place_id, r.lat, r.lon));
    list.append(row);
  }
  sheet.body.append(list);
}
